import type { ReactNode } from 'react'
import { WorkspaceHeader } from '@/components/workspace-header.tsx'

export function CustomerDocumentsHeader({
  customerId,
  customerName,
  actions
}: {
  customerId: number
  customerName?: string
  actions?: ReactNode
}) {
  return (
    <WorkspaceHeader className="sticky top-0 z-10 h-auto min-h-15 flex-wrap overflow-x-visible py-3">
      <div className="min-w-0">
        <h1 className="m-0 truncate text-base font-semibold">
          {customerName ? `${customerName} · 客户单据` : '客户单据'}
        </h1>
        <p className="text-content-muted m-0 text-xs">客户 ID：{customerId} · 仅展示当前客户单据</p>
      </div>
      <div className="ml-auto flex flex-wrap items-center justify-end gap-2">{actions}</div>
    </WorkspaceHeader>
  )
}
